import React from 'react';

const CallToAction = () => {
  return (
    <section id="cta">
      <h2>Ready to Party?</h2>
      <p>Check availability and book your rentals today!</p>
      <a href="#contact-form" className="cta-button">Book Now</a>
    </section>
  );
};

export default CallToAction;
